import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@nextui-org/react";
import { faClose } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// ---------------------- Props

interface ModalWrapperProps {
  title: string;
  parentRoute: string;
  content: ReactNode;
}

// ---------------------- Component

const ModalWrapper = ({ title, parentRoute, content }: ModalWrapperProps) => {
  // --------- Variables / Hooks

  const navigate = useNavigate();

  // --------- JSX

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/10 p-2 backdrop-blur-sm dark:bg-black/80 xs:p-4 sm:p-6">
      <div className="relative size-full max-w-[650px] rounded-xl bg-white p-1 shadow-xl dark:bg-gray-900">
        <div className="size-full rounded-xl border border-gray-50 p-2 p-4 dark:border-gray-950 sm:p-6">
          <div className="flex h-auto w-full flex-row items-center justify-between">
            {/*******************************************/}
            {/* Title */}
            {/*******************************************/}

            <h2 className="mb-4 text-base font-bold text-gray-800 dark:text-gray-200 xs:text-lg sm:text-2xl">
              {title}
            </h2>

            {/*******************************************/}
            {/* Close Button */}
            {/*******************************************/}

            <div className="-mr-3 -mt-4 flex h-auto flex-row items-center justify-end sm:-mt-5">
              <Button
                isIconOnly
                radius="full"
                className="bg-transparent p-2 text-current transition-all duration-200"
                onPress={() => navigate(parentRoute)}
              >
                <FontAwesomeIcon
                  icon={faClose}
                  className="h-5 text-gray-800 transition-transform duration-500 dark:text-gray-200 xs:h-5"
                />
              </Button>
            </div>
          </div>

          {/*******************************************/}
          {/* Modal Content */}
          {/*******************************************/}

          <div className="h-full w-full pb-10 text-gray-600 dark:text-gray-400 xs:pb-12">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalWrapper;
